export default __webpack_public_path__ + "static/media/feature.d2654792.svg";